import "./_Musics.scss";
import {useState} from "react";
import AudioPlayer2 from "../../components/MainAudioPlayer/AudioPlayer2";
import {motion} from 'framer-motion';
import Loader from "./Loader";
import { useFetch } from "../../utils/hooks/useFetch";

function Musics() {
  const [data, loading, error] = useFetch("/JSON/musics.json");
  const [trackIndex, setTrackIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const currentTrack = data[trackIndex] ?? null;

  return (
    <motion.div
      initial={{ translateY: "100vh" }}
      animate={{ translateY: 0, transition: { duration: 0.3 } }}
      exit={{ translateY: "-100vh", transition: { duration: 0.3 } }}
    >
      {error && <p>{error}</p>}
      <Loader visible={loading} />
      {currentTrack &&
        <AudioPlayer2
          trackIndex={trackIndex}
          setTrackIndex={setTrackIndex}
          currentTrack={currentTrack}
          tracks={data}
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
        />
      }
    </motion.div>
  );
}

export default Musics;